import React from "react";
import linkArrowIcon from "../assets/images/link-arrow.svg";
import { LinkInfo } from "../models/shared/LinkInfo";
import { replaceWithUnicode } from "../shared/string";
import SanityLink, { renderLinkTitle } from "./SanityLink";

type Props = {
  colorClasses?: string;
  leftMarginClass?: string;
  sizeClasses?: string;
  linkInfo: LinkInfo;
  border?: boolean;
};

const LinkWithArrow = ({
  border = true,
  colorClasses = "text-brand-primary-70 border-brand-primary-70",
  leftMarginClass = "ml-2",
  sizeClasses = "w-4 h-4",
  linkInfo
}: Props) => (
  <SanityLink
    {...linkInfo}
    className={`flex items-center group font-bold no-underline focus:outline-none focus:shadow-card-outline outline-none ${colorClasses} ${
      border ? "border-b" : ""
    }`}
  >
    <span>{replaceWithUnicode(renderLinkTitle(linkInfo))}</span>

    <svg
      className={`card-arrow group-hover:translate-x-1 ${leftMarginClass} ${sizeClasses}`}
    >
      <use xlinkHref={linkArrowIcon.url} />
    </svg>
  </SanityLink>
);

export default LinkWithArrow;
